import { Dialog as DialogRoot, type DialogProps } from './Dialog';
import { DialogClose, type DialogCloseProps } from './DialogClose';
import { DialogContent, type DialogContentProps } from './DialogContent';
import {
  DialogDescription,
  type DialogDescriptionProps,
} from './DialogDescription';
import { DialogOverlay, type DialogOverlayProps } from './DialogOverlay';
import { DialogPortal, type DialogPortalProps } from './DialogPortal';
import { DialogTitle, type DialogTitleProps } from './DialogTitle';
import { DialogTrigger, type DialogTriggerProps } from './DialogTrigger';

export const Dialog = {
  Root: DialogRoot,
  Content: DialogContent,
  Title: DialogTitle,
  Description: DialogDescription,
  Overlay: DialogOverlay,
  Close: DialogClose,
  Trigger: DialogTrigger,
  Portal: DialogPortal,
};

export type {
  DialogProps,
  DialogCloseProps,
  DialogContentProps,
  DialogDescriptionProps,
  DialogOverlayProps,
  DialogPortalProps,
  DialogTitleProps,
  DialogTriggerProps,
};
